<template>
  <core-view class="view" :fill-height="!$_isMobile">
    <template>
    <div class="center my-5" v-if="!loading">
      <v-form ref="form" lazy-validation>
        <div v-show="formAtual === 1">
          <div class="linha">
          <multi-field
            :rules="rules.obrigatorio"
            labelTexto="Pessoa"
            :style="{ width: 100 + '%' }"
            :minimizedInput="true"
            :dense="true"
            v-model="formulario.pessoa"
            :load="autocomplete.pessoa_transportador"
            :filterString="true"
            itemlabel="pesnome"
            itemvalue="pesidpessoa"
            itemdetail="pesnomefantasia"
            :radiolabel="['Codigo', 'Nome']"
            @filtro="$_onFiltro($event, 'pessoa')"
            />
          </div>

          <div class="linha">
            <multi-field
            :key="returnObject.produto"
            :rules="rules.produto"
            labelTexto="Produto"
            :minimizedInput="false"
            :dense="true"
            v-model="returnObject.produto"
            :load="autocomplete.produto"
            itemlabel="prodescricao"
            :filterString="true"
            itemvalue="procodigo"
            itemdetail="proidproduto"
            :radiolabel="['Codigo', 'Nome']"
            @filtro="$_onFiltro($event, 'produto')"
            @change="$_toProduto($event, 'produto')"/>
          </div>

          <v-form class="linha" :key="returnObject.produto" ref="formProduto" lazy-validation>
            <v-text-field label="UN"
            readonly
            maxlength=10
            :style="{ maxWidth: 19 + '%' }"
            validate-on-blur
            outlined v-model='formulario.produto.proun'
            @input="formulario.un = formulario.un.toUpperCase()"
            background-color="white" dense
            >
            </v-text-field>

            <v-currency-field label="Quantidade"
            :decimalLength="3"

            maxlength=10
            outlined v-model="quantidade"
            background-color="white" dense
            @input="$_toQuantidade()" >
            </v-currency-field>

            <v-currency-field label="Vl Unitario"
            :decimalLength="4"
            maxlength=11
            readonly
            outlined v-model="vlunitario"
            background-color="white" dense
            @input="$_toValorUnitario" >
            </v-currency-field>

            <v-text-field label="Total"
            :rules="rules.exorbitante"
            @focus.prevent
            maxlength=16
            readonly dense outlined
            background-color="white" v-model="$_total">
            </v-text-field>
          </v-form>
          <div class="linha justify-center">
            <v-btn color="primary" @click="$_addProduto()">
              Adicionar
            </v-btn>
          </div>
          <div>
            <produtos-table
            :produtos="produtos"
            @deletar="$_delProduto"/>
          </div>
        </div>

        <div v-show="formAtual === 2">
          <div class="linha">
            <btn-auto-complete
            :rules="rules.obrigatorio"
            validate-on-submit
            :returnObject="false" :dense="false"
            label="Natureza"
            :dados="autocomplete.natureza" icon="mdi-chevron-down"
            v-model="formulario.natureza" item-label="naodescricao"
            item-value="naoidnaturezaoperacao"
            >
            </btn-auto-complete>
          </div>
          <div class="linha">
          <multi-field
            :rules="rules.obrigatorio"
            ref="transportador"
            labelTexto="Transportador"
            :style="{ width: 100 + '%' }"
            :minimizedInput="true"
            v-model="formulario.transportador"
            :load="autocomplete.pessoa_transportador"
            :filterString="true"
            itemlabel="pesnome"
            itemvalue="pesidpessoa"
            itemdetail="pesnomefantasia"
            :radiolabel="['Codigo', 'Nome']"
            @filtro="$_onFiltro($event, 'transportador')"
            />
          </div>
          <div class="linha mt-5">
            <btn-auto-complete label="Tipo Frete"
            :rules="rules.obrigatorio"
            :dados="[{descricao: 'CIF'}, {descricao: 'FOB'}]" icon="mdi-chevron-down"
            v-model="formulario.tipofrete" itemLabel="descricao"
            :returnObject="false" :dense="false"
            item-value="descricao"
            >
            </btn-auto-complete>
            <btn-auto-complete label="Placa"
            :rules="rules.obrigatorio"
            :dados="autocomplete.placa" icon="mdi-chevron-down"
            v-model="returnObject.placa" item-label="veiplaca"
            :returnObject="true" :dense="false"
            item-value="veiidveiculo"
            @change="$_toPlaca($event)"
            >
            </btn-auto-complete>
          </div>
          <div class="linha">
            <v-text-field label="Espécie"
            :rules="rules.obrigatorio"
            v-model="formulario.especie"
            background-color="white" outlined
            >
            </v-text-field>
          </div>
          <div class="linha">
            <core-date-time-picker-field
              hide-details
              form
              v-model="formulario.dataemissao"
              :clearable="true"
              ref="dataemissao"
              :label="['Data de Emissão', 'Hora']"
              :rules="rules.obrigatorio"
            />
          </div>
          <div class="linha">
            <core-date-time-picker-field
              hide-details
              form
              v-model="formulario.datasaida"
              :clearable="true"
              ref="datasaida"
              :label="['Data de saída', 'Hora']"
              :rules="rules.datasaida"
            />
          </div>
        </div>
        <div class="divinferior">
          <v-btn height=36 color="green botaoinferior proximo my-5 mx-0" v-if="formAtual === 1" @click="$_trocaFormulario()">
            Próximo
          </v-btn>
          <div v-if="formAtual === 2" class="d-flex justify-center my-5">
            <v-btn height=45 color="gray botaoinferior black--text" v-if="formAtual === 2" @click="$_trocaFormulario()">
              Voltar
            </v-btn>
            <span>
            <v-btn height=45 color="green botaoinferior" v-if="!cadastro" @click="$_salvaDados()">
              Cadastrar
            </v-btn>
            <v-btn v-else height=45 class="green botaoinferior disable-click">
              <v-progress-circular
                indeterminate
                color="white" >
              </v-progress-circular>
            </v-btn>
          </span>
          </div>
        </div>
      </v-form>
    </div>
  </template>
</core-view>
</template>

<script>
// import errorHandler from '@/utils/error-handler';

import {
  ROUTE_NFE,
} from '@/constants/ROUTES';

import { NFE_STORAGE } from '@/constants/STORAGE';

import CoreView from '@/components/core/view/Index.vue';

import BtnAutoComplete from '@/components/core/btn-auto-complete/Index.vue';
import MultiField from '@/components/core/multi-field/Index.vue';
import errorHandler from '@/utils/error-handler';
import CoreDateTimePickerField from '@/components/core/variant/date-time-picker-field variant/Index.vue';
import ProdutosTable from '@/components/app/table/Index.vue';

import geraData from '@/utils/geradata';
// import moment from 'moment-timezone';

import db from '@/plugins/dexie';

import { mapActions } from 'vuex';
import { WsEnviaDados } from '../../utils/ws/websocket';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default {
  name: 'ViewNFe',

  components: {
    CoreView,
    BtnAutoComplete,
    MultiField,
    CoreDateTimePickerField,
    ProdutosTable,
  },

  data() {
    return {
      rules: {
        obrigatorio: [(v) => !!v || 'Este campo é obrigatório.'],
        // eslint-disable-next-line consistent-return
        datasaida: [(v) => {
          if (v < geraData(this.formulario.dataemissao, 'YYYY-MM-DD HH:mm')) {
            return 'A data de saída não pode ser menor que a de emissão.';
          }
        }],
        nulo: [
          (v) => !!v || 'Este campo é obrigatório.',
          (v) => v !== '0,000' || 'Este valor não pode ser nulo.',
          (v) => v !== '0,0000' || 'Este valor não pode ser nulo.',
        ],
        exorbitante: [
          (v) => {
            const valorMáximo = v.replace(/\./g, '').replace(',', '.');
            return valorMáximo <= 100000 || 'Este valor é muito alto.';
          },
        ],
        produto: [
          // eslint-disable-next-line consistent-return
          (v) => {
            // eslint-disable-next-line no-unused-expressions
            v; // ignorar error
            if (this.produtos.length <= 0) {
              this.formAtual = 1;
              return 'Adicione um produto para continuar.';
            }
          },
        ],
      },
      formulario: {
        natureza: null,
        pessoa: null,
        produto: {
          proidproduto: null,
          prodescricao: null,
          procodigo: null,
          proun: null,
        },
        quantidade: null,
        vlunitario: null,
        total: null,
        transportador: null,
        tipofrete: null,
        placa: null,
        especie: null,
        datasaida: geraData(),
        dataemissao: geraData(),
      },
      returnObject: {
        produto: null,
        placa: '',
      },

      quantidade: null,
      vlunitario: null,

      autocomplete: {
        natureza: null,
        produto: null,
        pessoa_transportador: null,
        placa: null,
      },

      empresa: null,
      formAtual: 1,
      loading: true,
      cadastro: false,
      produtos: [],
    };
  },
  computed: {
    $_total() {
      let { quantidade } = this;
      let { vlunitario } = this;
      let totalFormatado;
      if (typeof quantidade === 'string' || typeof vlunitario === 'string') {
        if (typeof quantidade === 'string') {
          quantidade = quantidade.replace(',', '.');
        }
        if (typeof vlunitario === 'string') {
          vlunitario = vlunitario.replace(',', '.');
        }
        const total = parseFloat(quantidade) * parseFloat(vlunitario);
        totalFormatado = new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        }).format(total);
      } else {
        const total = quantidade * vlunitario;
        totalFormatado = new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        }).format(total);
      }

      if (totalFormatado !== 'NaN' && totalFormatado !== '0,0000') {
        return totalFormatado;
      }
      return '';
    },
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },

  methods: {
    ...mapActions({
      $_empresa: 'empresa/find',
    }),

    async $_salvaDados() {
      // this.$refs.form.resetValidation();
      /* let now = moment();
      now = now.subtract(3,'hours'); */
      this.cadastro = true;
      /*       if (this.cadastro === true) {
        return
      } */
      if (this.$refs.form.validate()) {
        const idnuvem = getSessionStorage('user:useidnuvem', null);
        const dataNow = geraData();
        const novoNfeNuvem = {
          nofidnaturezaoperacao: this.formulario.natureza,
          nofidpessoa: Number(this.formulario.pessoa),
          noftotal: sessionStorage.getItem('total').replace('.', '').replace(',', '.'),
          nofidtransportador: this.formulario.transportador,
          noftipofrete: this.formulario.tipofrete,
          nofidveiculo: this.formulario.placa.veiidveiculo,
          nofespecie: this.formulario.especie,
          nofdataatualizacao: new Date().toISOString(),
          nofplaca: this.formulario.placa.veiplaca,
          nofnomepessoa: null,
          nofnometransportador: null,
          nofidnuvem: 'null',
          nofidusuario: idnuvem,
          nofdatacriacao: dataNow,
          nofdatasaida: this.formulario.datasaida,
          nofdataemissao: this.formulario.dataemissao,
          nofidempresa: parseInt(this.empresa, 10),
          // nofprodutodescricao: this.formulario.produto.prodescricao,
        };
        novoNfeNuvem.nofnomepessoa = await db.pessoa.where({ pesidpessoa: Number(this.formulario.pessoa) }).first();
        novoNfeNuvem.nofnometransportador = await db.pessoa.where({ pesidpessoa: Number(this.formulario.transportador) }).first();

        novoNfeNuvem.nofnomepessoa = novoNfeNuvem.nofnomepessoa.pesnome;
        novoNfeNuvem.nofnometransportador = novoNfeNuvem.nofnometransportador.pesnome;
        const nfedb = { ...novoNfeNuvem, nofprocessamento: 'EMITIR' };
        db.notafiscal.add(nfedb);
        for (const produto of this.produtos) {
          db.notafiscalitem.add({
            nfidproduto: produto.proidproduto,
            nfivalorunitario: produto.provlunitario,
            nfiquantidade: String(produto.proquantidade),
            nfiun: produto.proun,
            nfivalortotal: produto.prototal,
            nfidescricao: produto.prodescricao,
            nfidatanotafiscal: dataNow,
            nfidatacriacao: produto.addData,
            nfidataatualizacao: new Date().toISOString(),
          });
        }
        WsEnviaDados({ tipo: 'postNotaFiscal', msg: [novoNfeNuvem] });
        sessionStorage.removeItem(NFE_STORAGE.formulario);

        this.$router.push({
          ...this.$route,
          name: ROUTE_NFE.name,
        });
      } else {
        errorHandler('Alguns campos não foram preenchidos');
      }
      this.cadastro = false;
    },

    async $_findDb() {
      // Transformação do campo de pesidpessoa para String, para melhor utilização do Multi-field
      const pessoa = await db.pessoa.toArray();
      this.autocomplete.pessoa_transportador = pessoa.map((item) => ({ ...item, pesidpessoa: String(item.pesidpessoa) }));
      this.autocomplete.natureza = await db.naturezaoperacao.toArray();
      this.autocomplete.produto = await db.produto.toArray();
      this.autocomplete.placa = await db.veiculo.toArray();
      this.autocomplete.notafiscalitem = await db.notafiscalitem.toArray();
      this.loading = false;
      return null;
    },

    $_onFiltro(e, campo) {
      this.formulario[campo] = e;
    },

    async $_setupCampos() {
      if (!sessionStorage.getItem(NFE_STORAGE.formulario)) {
        await this.$_formToStorage();
        sessionStorage.removeItem('produtos');
      } else {
        this.formulario = JSON.parse(sessionStorage.getItem(NFE_STORAGE.formulario, this.formulario));
        this.returnObject.produto = this.formulario.produto ? this.formulario.produto.procodigo : '';
        this.returnObject.placa = this.formulario.placa ?? '';
        this.quantidade = this.formulario.quantidade ?? '';
        this.vlunitario = this.formulario.vlunitario ?? '';
        this.produtos = JSON.parse(sessionStorage.getItem('produtos')) ?? [];
      }
      this.$refs.form.resetValidation();
    },

    async $_formToStorage() {
      this.formulario.total = this.$_total;
      sessionStorage.setItem(NFE_STORAGE.formulario, JSON.stringify(this.formulario));
    },

    async $_toValorUnitario() {
      this.formulario.vlunitario = String(this.vlunitario).replace('.', ',') ?? '';
    },

    async $_toQuantidade() {
      this.formulario.quantidade = String(this.quantidade).replace('.', ',') ?? '';
    },

    async $_toProduto(event) {
      // Para evitar mudar o componente do Multi-field, faço um select aqui com o Procodigo, já que é único
      const obj = await db.produto.where({ procodigo: String(event) }).first();
      this.quantidade = 1;
      this.formulario.quantidade = 1;
      this.vlunitario = obj.proprecoa;
      this.formulario.vlunitario = obj.proprecoa;
      this.formulario.produto = {
        proidproduto: obj.proidproduto,
        prodescricao: obj.prodescricao,
        procodigo: obj.procodigo,
        proun: obj.proun,
      };
    },

    async $_toPlaca(event) {
      this.formulario.placa = {
        veiidveiculo: event.veiidveiculo,
        veiplaca: event.veiplaca,
      };
    },

    async $_getEmpresa() {
      this.empresa = await this.$_empresa();
      this.empresa = this.empresa[0].empidempresa;
    },

    async $_trocaFormulario() {
      this.formAtual = (this.formAtual === 2) ? 1 : 2;
    },

    async $_addProduto() {
      if (!this.$refs.formProduto.validate() || !this.returnObject.produto) {
        errorHandler('Selecione um produto para adicionar.');
        return;
      }
      this.produtos.push({
        prodescricao: this.formulario.produto.prodescricao,
        proidproduto: this.formulario.produto.proidproduto,
        proquantidade: this.quantidade,
        provlunitario: this.formulario.vlunitario,
        prototal: this.$_total.replace('.', '').replace(',', '.'),
        proun: this.formulario.produto.proun,
        addData: geraData(),
      });
      sessionStorage.setItem('produtos', JSON.stringify(this.produtos));
      console.log('clicado', this.produtos);
      this.quantidade = null;
      this.vlunitario = null;
      this.formulario.produto = {
        proidproduto: null,
        prodescricao: null,
        procodigo: null,
        proun: null,
      };
      this.formulario.quantidade = null;
      this.formulario.vlunitario = null;
      this.returnObject.produto = null; // deixa nulo pra "resetar" a key e limpar os outros campos
      this.$refs.form.resetValidation();
      this.$_formToStorage();
    },

    $_delProduto(produto) {
      console.log(produto, 'proenvio');
      this.produtos = this.produtos.filter((item) => JSON.stringify(item) !== JSON.stringify(produto));
      console.log(this.produtos, 'produtos delete');
      sessionStorage.setItem('produtos', JSON.stringify(this.produtos));
    },
  },

  watch: {
    formulario: {
      deep: true,
      handler() {
        this.$_formToStorage();
      },
    },
  },

  created() {
    this.$_findDb();
    this.$_setupCampos();
    this.$_getEmpresa();
  },

  beforeDestroy() {
    if (!sessionStorage.getItem(NFE_STORAGE.formulario)) {
      sessionStorage.removeItem('produtos');
      sessionStorage.removeItem('total');
    }
  },
};
</script>

<style scoped>
  .v-sheet--offset {
    top: 5px;
    position: relative;
  }

  .center {
    width: 100%;
    text-align: center;
  }

  .linha {
    display: flex;
  }

  .divinferior {
    text-align: center;
    width: 100%;
    bottom: 10px;
    right: 0%;
  }

  .botaoinferior {
    color: white;
    margin-right: 15%;
  }
  .botaoinferior.proximo {
    margin-right: 0%;
    margin-top: 50%;
  }

  .botaomargim {
    margin-right: 15%;
  }

  @media screen and (min-width:600px) {
    .tablet {
      display: flex;
    }
  }
  .view{
    max-width: 450px;
  }
  .disable-click{
    pointer-events: none;
  }
</style>
